<template>
	<div>
		<!-- 面包屑导航 -->
		<div>
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item class="mybread" :to="{ path: '/' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item class="mybread">管理员权限</el-breadcrumb-item>
				<el-breadcrumb-item class="mybread">量化考核分数</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<!-- 第一行搜索框和新增按钮 -->
		<el-row type="flex" align="middle" class="myRow">
			<el-col :span="2">班级搜索</el-col>
			<el-col :span="7">
				<el-input placeholder="请输入班级，例如计应21-1" v-model="queryInfo.banji" clearable>
					<el-button slot="append" icon="el-icon-search" @click="mylistUserWithScore()"></el-button>
				</el-input>
			</el-col>
			<el-col :span="3" :offset="1">考核日期选择</el-col>
			<el-col :span="7">
          <el-date-picker
            v-model="value1"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            unlink-panels
			@change="datachange()"
          >
          </el-date-picker>
        </el-col>

		</el-row>
		<!-- 用户列表-->
		<el-table border stripe height="620px" :data="scoreList" :header-cell-style="{
			background: '#fff1f0', height: '60px', color: '#000000'
		}">
			<el-table-column type="index" label="序号" width="80px"> </el-table-column>
			<el-table-column prop="username" label="学号/工号" width="200px">
			</el-table-column>
			<el-table-column prop="fullName" label="姓名" width="200px">
			</el-table-column>
			<el-table-column prop="score" label="量化考核管理分数" sortable width="220x">
			</el-table-column>
			<el-table-column prop="banji" label="班级" width="120x">
			</el-table-column>
			<el-table-column prop="mobile" label="手机号码" width="220x">
			</el-table-column>
			<el-table-column label="操作" width="450px">
				<template slot-scope="scope">
					<el-button @click="handDetailScore(scope.row)" size="middle" icon="el-icon-search">详情
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-dialog title="活动分数详情" :visible.sync="scoreDetailVisible" width="30%">
			<span>{{this.value1[0]}}至{{this.value1[1]}}各模块得分如下：</span>
			<el-table :data="scoreListDetail" style="width: 100%">
				<el-table-column prop="key" label="活动名称" width="280">
				</el-table-column>
				<el-table-column prop="val" label="活动分值" width="180">
				</el-table-column>

			</el-table>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="scoreDetailVisible = false">关闭</el-button>
			</span>
		</el-dialog>
		<!--分页区域-->
		<el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange"
			:current-page="queryInfo.pageNo" :page-sizes="[5, 10, 30, 50]" :page-size="queryInfo.pageSize"
			layout="total, sizes, prev, pager, next, jumper" :total=count>
		</el-pagination>
	</div>
</template>

<script>
import {  listUserWithScoreDetail, listUserWithScore } from "@/utils/api.js"

export default {
	data() {
		return {
			pickerOptions: {
				disabledDate(time) {
					return time.getTime() > Date.now();
				},
			},
			scoreList: [],
			scoreListDetail: {

			},
			roleInfo: {
				userId: '',
				role: ''
			},
			queryInfo: {
				fullName: '',
				role: '',
				pageSize: 30,
				pageNumber: 1,
				dateStart:'',
				dateEnd:'',
				banji:'',
				approve:1,
				datedetailStart:'',
				datedetailEnd:'',
			},
			remorveRole: {
				userId: '',
				role: ''
			},
			//控制上传申请书对话框的显示与隐藏
			scoreDetailVisible: false,
			activityList: [],
			total: '',
			value1:'',
			dataValue:'',
			

		}
	},
	created() {
		this.mylistUserWithScore();
	},
	methods: {

		mylistUserWithScore() {
			listUserWithScore(this.queryInfo).then(result => {
				if (result.code === '0000') {
					this.scoreList = result.data[0];
					console.log(result.data[0]);
					console.log("result.data[0]");

					this.count = result.data[1][0];

				} else {
					console.log(result)
				}
			})

		},
		//学生活动分数细则
		mylistUserWithScoreDetail(row) {
			const param = { "userId": row.userId, "dateStart":this.value1[0],"dateEnd":this.value1[1]};
			console.log(param);
			listUserWithScoreDetail(param).then(result => {
				if (result.code === '0000') {
					this.scoreDetailVisible = true;
					let arr = [];
					arr = Object.keys(result.data).map(val => ({
						key: val,
						val: result.data[val]
					}))
					console.log(arr)
					this.scoreListDetail = arr;

				} else {
					console.log(result)
				}
			})

		},

      //打开分数详情页
	  handDetailScore(row){
		console.log(row);
		this.mylistUserWithScoreDetail(row);

	  },
		//监听PageSize的长度
		handleSizeChange(newSize) {
			this.queryInfo.pageSize = newSize;
			this.mylistUserWithScore();

		},
		//监听页码值改变的事件
		handleCurrentChange(newPage) {
			this.queryInfo.pageNumber = newPage;
			this.mylistUserWithScore();
			this.queryInfo.pageNumber = 1;
		},
		datachange(){
			this.queryInfo.dateStart=this.value1[0];
			this.queryInfo.dateEnd=this.value1[1];
			this.mylistUserWithScore();
		
		},
	
	}
}
</script>

<style>
.title {
	font-size: 20px;
}

.basicInfo {
	height: 300px;
	width: 500px;
	background-color: bisque;
}

.el-button--primary {
	background-color: darkred;
	color: #fff;
	border-color: darkred;
	width: 130px;
	font-size: 18px;
}

.el-popover {
	padding: 10px !important;
	font-size: 18px !important;
	border: 1px solid gray !important;
	background-color: #f4eded !important;
	height: 50px;
}

.el-pagination button:hover {
	color: rgb(227, 122, 122);
}

.el-pagination li.number.active {
	background: rgb(229, 139, 139) !important;
}

.el-pagination .el-select .el-input .el-input__inner {
	color: #000 !important;
	border-color: rgb(229, 139, 139);
	background-color: #fff;
}

.el-upload {
	width: 100%;
}

.el-upload .el-upload-dragger {
	width: 100%;
}

.el-breadcrumb .el-breadcrumb__inner {
	color: grey;
	font-size: 18px;
}

.myRow {
	margin-top: 50px;
	margin-bottom: 30px;
	margin-left: 20px;
}

.el-tag+.el-tag {
	margin-left: 10px;
}
.hit{
	font-size: 18px;
	
}
</style>